<template>
  <bt-realization-form :value="realization" :title="title" @save="save" :editable="editable"
                       printable @print="print" :backRoute="$route.name"
                       :newExpenseRoute="{name: 'business-trip-realization-detail-new-expense'}"
                       :expenseDetailRoute="{name: 'business-trip-realization-detail-expense-detail'}"
                       @generateExpense="generateExpense" @updateExpense="updateExpense"
                       :cancelable="editable" @cancel="cancel"
                       :deletable="editable" @delete="_delete" @input="change" @close="close"
                       @tempLock="tempLock"
                       v-if="loaded"/>
  <h2 v-else>Loading...</h2>
</template>

<script>
import BtRealizationForm from './BtRealizationForm'
import Promise from 'promise-polyfill'
import Vuex from 'vuex'
import _ from 'lodash'

const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')
const tripExpenseStore = Vuex.createNamespacedHelpers('TripExpense')

export default {
  name: 'BtRealizationDetail',
  components: {
    BtRealizationForm
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    backRoute: {
      type: [String, Object],
      required: false,
      default: null
    }
  },
  computed: {
    title () {
      return 'Business Trip Realization' + (this.revision ? ' (REVISION)' : '')
    }
  },
  data () {
    return {
      revision: false,
      realization: {},
      loaded: false,
      modified: false,
      editable: true
    }
  },
  methods: {
    ...btRealizationStore.mapActions({
      getRealization: 'getRealization',
      getRealizationExpense: 'getRealizationExpense',
      updateRealization: 'updateRealization',
      printLppd: 'printLppd',
      generateRealizationExpense: 'generateRealizationExpense',
      deleteRealization: 'deleteRealization'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    ...tripExpenseStore.mapActions({
      listExpenseTypes: 'list'
    }),
    loadResources () {
      const self = this
      self.loaded = false
      self.modified = false

      const realizationresource = new Promise((resolve, reject) => {
        self.getRealization({vueinstance: self, id: self.id})
          .then(res => {
            self.editable = res.content.documentState === 'DRAFTED' || res.content.documentState === 'REVISION' ||
              res.editable
            resolve(res.content)
          }).catch(err => reject(err))
      })

      realizationresource.then(res => {
        self.realization = _.cloneDeep(res)
        if (self.realization.documentState === 'REVISION') {
          self.realization.documentState = 'DRAFTED'
          self.revision = true
        }
        self.realization.sppdEmployee.displayName = res.sppdEmployee.employee.name +
          ' (' + res.sppdEmployee.employee.nik + ') - ' + res.sppdEmployee.sppd.batchNo
        self.loaded = true
      })
        .catch(err => self.$error(err))
    },
    save (realization) {
      const self = this

      realization.expenses.forEach(x => {
        delete x.documentState
      })

      const simpan = () => {
        if (realization.sppdState === null) {
          realization.sppdState = 'REALIZATION'
        }
        self.updateRealization({vueinstance: self, id: self.id, sppdReal: realization})
          .then(res => {
            self.modified = false
            self.$success('Business Trip Realization ' + res.batchNo + ' updated')
            self.$router.replace(this.backRoute)
          })
          .catch(err => self.$error(err))
      }

      if (realization.expenses.length === 0) {
        self.$error('Must have Expenses(s)')
      } else {
        if (realization.documentState === 'SUBMITTED') {
          self.showConfirmation({
            title: 'Submit Business Trip Realization. This process cannot be undone.',
            message: 'Are you sure?',
            buttons: [
              {
                label: 'Yes',
                handler: () => {
                  self.closeConfirmation()
                  simpan()
                }
              },
              {label: 'No', handler: () => self.closeConfirmation()}
            ]
          })
        } else {
          simpan()
        }
      }
    },
    change (value) {
      this.modified = true
      this.realization = value
    },
    close () {
      this.$router.replace(this.backRoute)
    },
    print (value) {
      const self = this

      const id = value.id
      value.expenses.forEach(x => { delete x.sppdReal.id })

      const printReport = (type) => {
        self['print' + type]({vueinstance: self, id: id})
          .then(res => {
            const url = URL.createObjectURL(res)
            window.open(url)
          }).catch(err => self.$error(err))
      }

      self.showConfirmation({
        title: 'Please choose print type',
        msssage: '',
        buttons: [
          {label: 'LPPD', handler: () => printReport('Lppd')},
          {label: 'Close', handler: () => self.closeConfirmation()}
        ]
      })
    },
    generateExpense () {
      const self = this

      const generate = () => {
        var fromCities = '-'
        var toCities = '-'
        if (self.realization.fromLat != null && self.realization.fromLong != null && self.realization.toLat != null && self.realization.toLong != null) {
          fromCities = self.realization.fromLat + ',' + self.realization.fromLong
          toCities = self.realization.toLat + ',' + self.realization.toLong
        }

        const promises = [
          self.listExpenseTypes({vueinstance: self}),
          self.generateRealizationExpense({
            vueinstance: self,
            id: self.realization.sppdEmployee.id,
            fromdate: self.realization.fromDate,
            todate: self.realization.toDate,
            fromcity: fromCities,
            tocity: toCities
          })
        ]

        // drop all generated expense
        self.$set(self.realization, 'expenses', _.filter(self.realization.expenses, (o) => !o._tag.generated))

        // new expenses
        Promise.all(promises).then(res => {
          const expenseTypes = res[0].map(x => x.tripExpenseType)
          const generatedExpenses = self.realization.expenses
            .filter(x => !expenseTypes.includes(x.tripExpenseType) && !x._tag.generated)

          const newExpenses = []
          res[1].forEach(x => {
            if (_.findIndex(generatedExpenses,
              (o) => o.tripDate === x.tripDate && o.tripExpenseType === x.tripExpenseType) < 0) {
              newExpenses.push({...x, _tag: {status: 'new', generated: true}})
            }
          })

          self.$set(self.realization, 'expenses', self.realization.expenses.concat(newExpenses))

          generatedExpenses.forEach(x => {
            if (x.tripDate < self.realization.fromDate || x.tripDate > self.realization.toDate) {
              x._tag.status = 'delete'
            } else {
              x._tag.status = 'normal'
            }
          })

          self.closeConfirmation()
        }).catch(err => self.$error(err))
      }

      self.showConfirmation({
        title: 'Generate expenses? All previous generated expense(s) will be generated again.',
        message: 'Are you sure?',
        buttons: [
          {label: 'Yes', handler: generate},
          {label: 'No', handler: self.closeConfirmation}
        ]
      })
    },
    updateExpense (expenses) {
      this.$set(this.realization, 'expenses', expenses)
      this.modified = true
    },
    cancel (realization) {
      const self = this

      const batal = () => {
        realization.sppdState = 'CANCELED'
        realization.documentState = 'LOCKED'
        self.save(realization)
        self.closeConfirmation()
      }

      self.showConfirmation({
        title: 'Cancel Business Trip Realization? This process cannot be undone.',
        message: 'Are you sure?',
        buttons: [
          {label: 'Yes', handler: batal},
          {label: 'No', handler: () => self.closeConfirmation()}
        ]
      })
    },
    tempLock (realization) {
      const self = this

      const batal = () => {
        realization.sppdState = 'TEMP_CLOSED'
        realization.documentState = 'LOCKED'
        self.save(realization)
        self.closeConfirmation()
      }

      self.showConfirmation({
        title: 'Temp Locked Business Trip Realization? This process cannot be undone.',
        message: 'Are you sure?',
        buttons: [
          {label: 'Yes', handler: batal},
          {label: 'No', handler: () => self.closeConfirmation()}
        ]
      })
    },
    _delete (realization) {
      const self = this
      const yesHandler = () => {
        self.deleteRealization({vueinstance: self, id: realization.id})
          .then(res => {
            self.closeConfirmation()
            self.$router.replace(this.backRoute)
          }).catch(err => {
            self.$error(err)
            self.closeConfirmation()
          })
      }

      const noHandler = () => {
        self.closeConfirmation()
      }

      self.showConfirmation({
        message: 'Are you sure?',
        title: 'Delete Business Trip Realization ' + realization.batchNo + '?',
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.modified) {
      const yesHandler = () => {
        this.closeConfirmation()
        next()
      }

      const noHandler = () => {
        this.closeConfirmation()
      }

      this.showConfirmation({
        message: 'Are you sure?',
        title: 'This Business Trip Expense Realization will not saved.',
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationDetail.vue